import React, { useState, useEffect } from 'react';
import { showtoast } from '../Utilities/Utilities';
import { restrictToAlphabetic, OnlyNumeric } from '../Utilities/InputValidations';
import './CustomerInfo.css';

export const CustomerInfo = ({ generateMobileOTP, oTPSentResult, oTPbtn, verifyMobileOTP, oTPVerifyResult,
    generateEmailOTP, emailOTPSentResult, emailOTPbtn, verifyEmailOTP, emailOTPVerifyResult,
    updateBuyerInfo, buyerInfo, isEmailAlreadyVerified, emailOTPCountdn, otpCountdn, isTokenValid, reqParams, emailEditEnable, updateEmailVerificationOnUpdate,
    isOTPInputVisible, isEmailOTPInputVisible }) => {

    const [showAdditionalInfo, setShowAdditionalInfo] = useState(false);
    const [inputOTP, setInputOTP] = useState(''); 
    const [inputEmailOTP, setInputEmailOTP] = useState('');

    function convertSecondsToMMSS(seconds) {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
    const [otpCountdnFormate, setOtpCountdnFormate] = useState(convertSecondsToMMSS(otpCountdn));
    const [emailOtpCountdnFormate, setEmailOtpCountdnFormate] = useState(convertSecondsToMMSS(emailOTPCountdn));

    const toggleAdditionalInfo = () => {
        setShowAdditionalInfo(!showAdditionalInfo);
    };

    const handleInputOTPChange = (event) => { 
        setInputOTP(event.target.value); 
    };

    const handleInputEmailOTPChange = (event) => {
        setInputEmailOTP(event.target.value);
    };

    const handleBuyerInfoChange = (key, e) => {
        updateBuyerInfo(key, e.target.value);
    }

    const generateMobileOTPHandler = (e, MobileNo) => {
        e.preventDefault();
        if (!buyerInfo.MobileNoVerified) {
            setInputOTP("");
            generateMobileOTP(e, MobileNo);
        }
    }

    const generateEmailOTPHandler = (e, EmailID) => {
        e.preventDefault();
        if ((oTPVerifyResult && oTPVerifyResult.resultStatus === "Success") || (isTokenValid && reqParams.MobileNo.length == 10)) {
            if (!isEmailAlreadyVerified) {
                setInputEmailOTP("");
                generateEmailOTP(e, EmailID)
            }
        }
        else {
            showtoast("error", "Please verify mobile no.");
        }
    }

    const validateEmail = (e) => {
        const value = e.target.value;
        // Replace if first character is not alphanumeric
        let sanitizedValue = value.replace(/^[^a-zA-Z0-9]/, '');

        // Remove all special characters except "@" after the first character
        sanitizedValue = sanitizedValue.replace(/[^a-zA-Z0-9@.]/g, '');

        // Ensure there's only one "@" symbol
        const atCount = (sanitizedValue.match(/@/g) || []).length;
        if (atCount > 1) {
            sanitizedValue = sanitizedValue.slice(0, sanitizedValue.lastIndexOf('@'));
        }

        e.target.value = sanitizedValue; 
    };

    const validateGST = (e) => {
        const value = e.target.value;
        // Replace if first character is not alphanumeric
        let sanitizedValue = value.replace(/^[^a-zA-Z0-9]/, '');
        sanitizedValue = sanitizedValue.replace(/[^a-zA-Z0-9]/g, '');

        e.target.value = sanitizedValue; 
    }

    const validatePincode = (e) => {
        let value = e.target.value;

        // Remove any non-numeric characters
        value = value.replace(/[^0-9]/g, '');

        // Limit the pincode to 6 digits (or any other length requirement)
        if (value.length > 6) {
            value = value.slice(0, 6);
        }

        e.target.value = value;
    };

    const handleEmailUpdate = () => {
        updateEmailVerificationOnUpdate();
    }

    useEffect(() => {
        setOtpCountdnFormate(convertSecondsToMMSS(otpCountdn));
        setEmailOtpCountdnFormate(convertSecondsToMMSS(emailOTPCountdn)); 

    }, [otpCountdn, emailOTPCountdn]);

    return (
        <div className="col-lg-7 form-container">
            <h3 className="Choice-color">Smart Choice!</h3>

            <div className="progressbar-demo-new">
                <div className="progressbar">
                    <div className={oTPVerifyResult && oTPVerifyResult.resultStatus === "Success" && emailOTPVerifyResult && emailOTPVerifyResult.resultStatus === "Success" ? 'progress-solid' : 'progress'}
                        id="progress" style={{ width: '50%' }} ></div>
                    <div className="progress-step progress-step-active" data-title="Add plan to Cart"></div>
                    {oTPVerifyResult && oTPVerifyResult.resultStatus === "Success" && emailOTPVerifyResult && emailOTPVerifyResult.resultStatus === "Success" && 
                        <div className="progress-2" id="progress-2" style={{ width: '50%' }} ></div>
                    }
                    <div className={`progress-step ${oTPVerifyResult && oTPVerifyResult.resultStatus === "Success" && (isEmailAlreadyVerified || (emailOTPVerifyResult && emailOTPVerifyResult.resultStatus === "Success")) && 'progress-step-active'}`}
                        data-title="Verify your information"></div>
                    <div className="progress-step" data-title="Make Payment"></div>
                </div>
            </div>


            <h5 className="custom-text-bold-p">Please provide the following to send the vouchers</h5>
            <form className="custom-text-bold-form-me">
                <div className="mb-2">
                    <label htmlFor="BuyerName" className="form-label" style={{ backgroundColor: '#271414' }}>Name<span className="text-danger">*</span></label>
                    <input type="text" value={buyerInfo.BuyerName} name="BuyerName" className="form-control-krle" id="name" autoComplete="off" onInput={restrictToAlphabetic} onChange={(e) => handleBuyerInfoChange("BuyerName", e)} placeholder="Enter Your name" maxLength="30" />
                </div>
                {isTokenValid && reqParams.MobileNo && reqParams.MobileNo.length === 10 ?
                    <div className="mb-2">
                        <div className="mob-no-verified">
                            Your mobile number (+91) {reqParams.MobileNo[0] + "XXX" + reqParams.MobileNo.slice(4, 7) + "XXX"} is verified.
                            <span>  <img src="images/check-tick.png" alt="Subtract" className="img-fluid Subtract-htmlFor-mid" width="22" height="22" /> </span>
                        </div>
                    </div>
                    :
                    < div className="mb-2 position-relative">
                        <label htmlFor="MobileNo" className="form-label">Mobile Number<span className="text-danger">*</span></label>
                        <input type="text" value={buyerInfo.MobileNo} autoComplete="off" name="MobileNo" className="form-control-krle" id="mobile" onChange={(e) => handleBuyerInfoChange("MobileNo", e)} onInput={OnlyNumeric} placeholder="Enter Mobile Number" maxLength="10" style={{ paddingRight: '100px' }}
                            disabled={oTPVerifyResult && oTPVerifyResult.resultStatus === "Success"} />
                        {!oTPbtn ?
                            <button type="button" className={!buyerInfo.MobileNoVerified ? "get-otp-btn-custom" : "get-otp-btn-custom-disable"} onClick={(e) => generateMobileOTPHandler(e, buyerInfo.MobileNo)} disabled={buyerInfo.MobileNoVerified}>Get OTP</button>
                            : <button type="button" className="get-otp-btn-custom-disable" disabled>Get OTP</button>
                        }

                        {oTPSentResult && oTPSentResult.resultStatus === "Success" &&
                            <p className="succe-ssf-ully">{oTPSentResult.resultMessage}</p>
                        }
                        {oTPSentResult && oTPSentResult.resultStatus !== "Success" &&
                            <p className="failled-otp">{oTPSentResult.resultMessage}</p>
                        }
                    </div>
                }

                {!buyerInfo.MobileNoVerified && isOTPInputVisible && (
                    <div className="mb-2 position-relative">
                        <label htmlFor="mobile" className="form-label">Mobile OTP<span className="text-danger">*</span></label>
                        <input
                            type="password"
                            value={inputOTP}
                            autoComplete="off"
                            className="form-control-krle"
                            id="mobileOTP"
                            onChange={(e) => {
                                handleInputOTPChange(e);
                            }} 
                            onInput={OnlyNumeric}
                            placeholder="Enter your OTP"
                            maxLength="4"
                            style={{ paddingRight: '100px' }}
                        />
                        <button
                            type="button"
                            className="get-otp-btn-custom"
                            onClick={(e) => verifyMobileOTP(e, inputOTP, buyerInfo.MobileNo)}
                        >
                            Verify OTP
                        </button>
                        {oTPbtn && !buyerInfo.MobileNoVerified && oTPSentResult && (
                            <p className="succe-ssf-ully-verify">
                                Resent OTP (in {otpCountdnFormate})
                            </p>
                        )}
                    </div>
                )}

                {oTPVerifyResult &&
                    <div className="mb-2">
                        <div className="mob-no-verified">
                            {oTPVerifyResult.resultMessage}
                            {oTPVerifyResult.resultStatus === "Success" &&
                                <span>  <img src="images/check-tick.png" alt="Subtract" className="img-fluid Subtract-htmlFor-mid"  width="22" height="22" /> </span>
                            }
                        </div>
                    </div>
                }

                <div className="mb-2 position-relative">
                    <label htmlFor="EmailID" className="form-label">Email address<span className="text-danger">*</span></label>
                    <input type="email" value={buyerInfo.EmailID} autoComplete="off" name="EmailID" className="form-control-krle" id="email"
                        disabled={(isEmailAlreadyVerified && !emailEditEnable) || (emailOTPVerifyResult && emailOTPVerifyResult.resultStatus === "Success") || !((oTPVerifyResult && oTPVerifyResult.resultStatus === "Success") || (isTokenValid && reqParams.MobileNo.length == 10))} onInput={validateEmail} onChange={(e) => handleBuyerInfoChange("EmailID", e)} maxLength="50" placeholder="Enter your Email address" style={{ paddingRight: '100px' }} />
                    {isEmailAlreadyVerified && !emailEditEnable ?
                        <button type="button" className="get-otp-btn-custom" onClick={handleEmailUpdate} >Update</button> :
                        <>
                            {!emailOTPbtn ?
                                <button type="button" className={emailEditEnable ? "get-otp-btn-custom" : "get-otp-btn-custom-disable"} onClick={(e) => generateEmailOTPHandler(e, buyerInfo.EmailID)} disabled={!emailEditEnable}>Get OTP</button>
                                : <button type="button" className="get-otp-btn-custom-disable" disabled>Get OTP</button>
                            }
                        </>
                    }
                    {emailOTPSentResult && emailOTPSentResult.resultStatus === "Success" &&
                        <p className="succe-ssf-ully">{emailOTPSentResult.resultMessage}</p>
                    } 
                    {emailOTPSentResult && emailOTPSentResult.resultStatus !== "Success" &&
                        <p className="failled-otp">{emailOTPSentResult.resultMessage}</p>
                    } 
                </div>
                {!isEmailAlreadyVerified && isEmailOTPInputVisible && (
                    <div className="mb-2 position-relative">
                        <label htmlFor="email" className="form-label">Email OTP<span className="text-danger">*</span></label>
                        <input
                            type="password"
                            value={inputEmailOTP}
                            autoComplete="off"
                            className="form-control-krle"
                            id="emailOTP"
                            onChange={(e) => {
                                handleInputEmailOTPChange(e);
                            }} 
                            onInput={OnlyNumeric}
                            placeholder="Enter your OTP"
                            maxLength="4"
                            style={{ paddingRight: '100px' }}
                        />
                        <button
                            type="button"
                            className="get-otp-btn-custom"
                            onClick={(e) => verifyEmailOTP(e, inputEmailOTP, buyerInfo.EmailID)}
                        >
                            Verify OTP
                        </button>
                        {emailOTPbtn && !isEmailAlreadyVerified && emailOTPSentResult && (
                            <p className="succe-ssf-ully-verify">Resent OTP (in {emailOtpCountdnFormate})</p>
                        )}
                    </div>
                )}

                {emailOTPVerifyResult &&
                    <div className="mb-2">
                        <div className="mob-no-verified">
                            {emailOTPVerifyResult.resultMessage}
                            {emailOTPVerifyResult.resultStatus === "Success" &&
                                <span> <img src="images/check-tick.png" alt="check" className="img-fluid Subtract-htmlFor-mid" width="22" height="22" /> </span>
                            }
                        </div>
                    </div>
                }

                <div className={`Additional ${showAdditionalInfo === true ? 'active' : ''}`}>
                    <div className="Additional-info" onClick={toggleAdditionalInfo}>
                        <i className="fas fa-chevron-down"></i>
                        <span> Additional Information</span>
                    </div>
                    {showAdditionalInfo && <div>
                        <div className=" mb-2 additional-content">
                            <label htmlFor="CompanyName" className="form-label">Company Name</label>
                            <input type="text" value={buyerInfo.CompanyName} autoComplete="off" name="CompanyName" className="form-control-krle" id="companyName" onInput={restrictToAlphabetic} onChange={(e) => handleBuyerInfoChange("CompanyName", e)} placeholder="Enter your Organization name" maxLength="50" />
                        </div>
                        <div className=" mb-2 additional-content">
                            <label htmlFor="GSTNo" className="form-label">GST Number</label>
                            <input type="text" value={buyerInfo.GSTNo} autoComplete="off" name="GSTNo" className="form-control-krle" id="gstNumber" onInput={validateGST} onChange={(e) => handleBuyerInfoChange("GSTNo", e)} placeholder="Enter your GST Number" maxLength="15" />
                        </div>
                        <div className=" mb-2 additional-content">
                            <label htmlFor="PinCode" className="form-label">Pincode</label>
                            <input type="text" value={buyerInfo.PinCode || ''} autoComplete="off" name="PinCode" className="form-control-krle" id="pinCode" onInput={validatePincode} onChange={(e) => handleBuyerInfoChange("PinCode", e)} placeholder="Enter Postal Code" maxLength="6" />
                        </div>
                        <div className=" mb-2 additional-content">
                            <label htmlFor="CompanyAddress" className="form-label">Registered Address</label>
                            <input type="text" value={buyerInfo.CompanyAddress} autoComplete="off" name="CompanyAddress" className="form-control-krle" id="companyAddress" onInput={restrictToAlphabetic} onChange={(e) => handleBuyerInfoChange("CompanyAddress", e)} placeholder="Enter your Organization address" maxLength="150" />
                        </div>
                    </div>}
                </div>


            </form>
        </div>

    );
}

